var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackgroundVerification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9243",
    "data-name": "Group 9243",
    transform: "translate(-14259 -9096)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1803",
    "data-name": "Ellipse 1803",
    cx: 28,
    cy: 28,
    r: 28,
    transform: "translate(14259 9096)",
    fill: "#d34a7c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10709",
    "data-name": "Group 10709",
    transform: "translate(-3902 -403)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vcard",
    d: "M26.25,14.531v-.937a.451.451,0,0,0-.468-.468H17.344a.451.451,0,0,0-.468.468v.938a.451.451,0,0,0,.468.468h8.438a.451.451,0,0,0,.468-.468Zm0-3.808V9.9a.507.507,0,0,0-.154-.373.513.513,0,0,0-.373-.154H17.4a.507.507,0,0,0-.373.154.513.513,0,0,0-.154.373v.82a.507.507,0,0,0,.154.373.513.513,0,0,0,.373.154h8.32A.507.507,0,0,0,26.1,11.1a.513.513,0,0,0,.154-.373Zm0-3.692V6.093a.451.451,0,0,0-.468-.468H17.344a.451.451,0,0,0-.468.468v.938a.451.451,0,0,0,.468.468h8.438a.451.451,0,0,0,.468-.468ZM30,2.343V20.156A2.35,2.35,0,0,1,27.657,22.5H22.5V21.092a.451.451,0,0,0-.468-.468h-.937a.451.451,0,0,0-.468.468V22.5H9.375V21.092a.451.451,0,0,0-.468-.468H7.969a.451.451,0,0,0-.468.468V22.5H2.344a2.256,2.256,0,0,1-1.655-.688A2.258,2.258,0,0,1,0,20.157V2.344A2.257,2.257,0,0,1,.688.688,2.257,2.257,0,0,1,2.344,0H27.657a2.256,2.256,0,0,1,1.655.688A2.256,2.256,0,0,1,30,2.343Z",
    transform: "translate(18174 9516)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bxs-user-check",
    d: "M7.375,12.592a2.507,2.507,0,1,0,0-5.014,2.507,2.507,0,1,0,0,5.014Zm.729.679H6.646A3.618,3.618,0,0,0,3,16.852v.716h8.75C11.75,14.877,10.115,13.27,8.1,13.27Z",
    transform: "translate(18176.641 9513.963)",
    fill: "#d34a7c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundVerification);
export default __webpack_public_path__ + "static/media/background-verification.b3b6eda30c4a3ba27b9c4405fd93de97.svg";
export { ForwardRef as ReactComponent };